import PropTypes from 'prop-types';
import { colors } from 'bench-style-constants';
import { lighten } from 'color-helpers';
import styled from 'styled-components';

const styleTypes = {
  success: {
    color: colors.bonsai,
  },
  error: {
    color: colors.copper,
  },
};

const NotificationMessage = styled.div`
  background-color: ${({ styleType }) => lighten(styleTypes[styleType].color, 0.8)};
  color: ${({ styleType }) => styleTypes[styleType].color};
  border-radius: 2px;
  font-size: 12px;
  font-weight: 300;
  line-height: 16px;
  padding: 8px 12px;
`;

NotificationMessage.propTypes = {
  styleType: PropTypes.oneOf(Object.keys(styleTypes)).isRequired,
};

export default NotificationMessage;
